export function raiseGeneralError() {
    raiseError('general.something_went_wrong', 'general.there_was_a_problem_with_your_request')
}

export function raiseError(message: string, description: string) {
    const toast = useToast()
    const nuxtApp = useNuxtApp()
    
    toast.add({
        title: nuxtApp.$i18n.t(message),
        description: nuxtApp.$i18n.t(description),
        icon: 'i-lucide-circle-x',
        color: 'red'
    })
}

export function raiseSuccess(message: string, description?: string) {
    const toast = useToast()
    const nuxtApp = useNuxtApp()
    
    toast.add({
        title: nuxtApp.$i18n.t(message),
        description: description ? nuxtApp.$i18n.t(description) : undefined,
        icon: 'i-lucide-check-circle',
        color: 'green'
    })
}